import React from "react"
import { Flex, Text, Icon, AlertBox, INNER_MAX_WIDTH } from "@capioweb/ui-components/src"
import { AlertsContext, LocalesContext } from "../../context"
import { Alert as AlertBase } from "../Core/pageBase"
import { sendAlertExpandDataLayerPush } from "../../utils"

interface AlertBannerProps {
	pageAlerts?: Record<"common" | "local", AlertBase[]>
}

const AlertBanner: React.FC<AlertBannerProps> = (props) => {
	const { translate, translationKeys } = React.useContext(LocalesContext)
	const [expanded, setExpanded] = React.useState(false)
	const alertsContext = React.useContext(AlertsContext)

	//Combines all alerts and sorts them by type
	const pageAlertsMobile = [
		...props.pageAlerts?.common,
		...props.pageAlerts?.local,
	]
		.sort((a, b) => (a.type > b.type ? 1 : b.type > a.type ? -1 : 0))
		.slice(0, 4)

	//Removes all alerts that should be hidden on desktop
	const pageAlertsDesktop = pageAlertsMobile.filter(
		(alert) => !alert.hideOnDesktop
	)

	//Pushes all alerts to the dataLayer
	const dataLayerPushAlert = () => {
		pageAlertsMobile.map(
			(alert: { type: string; header: string; isGlobal: boolean }) => {
				sendAlertExpandDataLayerPush(alert.header, alert.isGlobal, alert.type)
			}
		)
	}

	return (
		<Flex
			px={3}
			backgroundColor="coral33"
			flexDirection="column"
			display={
				alertsContext.hideAlerts
					? "none"
					: {
						_: pageAlertsMobile.length > 0 ? "flex" : "none",
						m: pageAlertsDesktop.length > 0 ? "flex" : "none",
					}
			}
		>
			<Flex
				maxw={{ _: 1, m: INNER_MAX_WIDTH }}
				w={1}
				m="auto"
				pt={pageAlertsDesktop.length > 1 ? 6 : { _: 6, m: 0 }}
				flexWrap="wrap"
				columnGap={3}
				rowGap={3}
				position="relative"
				flexDirection={{ _: "column", m: "row" }}
			>
				<Flex
					position="absolute"
					top="12px"
					right="-4px"
					onClick={() => alertsContext.setHideAlerts(true)}
				>
					<Icon icon="close"></Icon>
				</Flex>

				<>
					{pageAlertsMobile.length > 0 &&
						pageAlertsMobile.map((alert, i, arr) => {
							return (
								<Flex
									display={{ _: "flex", m: "none" }}
									w={{ _: 1, m: "calc(50% - 12px)" }}
									mx={arr.length <= 1 ? "auto" : 0}
									key={`${i}-${alert.type}`}
								>
									<AlertBox
										{...alert}
										expanded={expanded}
										pageAlerts={arr}
										index={i}
									></AlertBox>
								</Flex>
							)
						})}

					{pageAlertsDesktop.length > 0 &&
						pageAlertsDesktop.map((alert, i, arr) => {
							return (
								<Flex
									display={{ _: "none", m: "flex" }}
									w={{ _: 1, m: "calc(50% - 12px)" }}
									mx={arr.length <= 1 ? "auto" : 0}
									key={`${i}-${alert.type}`}
								>
									<AlertBox
										{...alert}
										expanded={expanded}
										pageAlerts={arr}
										index={i}
									></AlertBox>
								</Flex>
							)
						})}
				</>
			</Flex>
			<Flex px={1} mx="auto" minh={6}>
				<Flex
					my="auto"
					style={{ cursor: "pointer" }}
					columnGap={0.5}
					onClick={() => {
						setExpanded(!expanded)
						!expanded && dataLayerPushAlert()
					}}
				>
					<Icon icon={expanded ? "chevron-up" : "chevron-down"}></Icon>
					<Text textDecoration="underline" mb={0}>
						{expanded
							? translate(translationKeys.hideDetails)
							: translate(translationKeys.showDetails)}
					</Text>
				</Flex>
			</Flex>
		</Flex>
	)
}

export { AlertBanner }
